import Vue from 'vue'
import App from './App.vue'
import router from '@/common/router/index'
import store from '@/store'
import axios from '@/util/axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import SlideVerify from 'vue-monoplasty-slide-verify';
import moment from 'moment' //导入文件
import 'moment/locale/zh-cn'
import '@/style/index.less'
import {install} from '@icon-park/vue/es/all';
import '@icon-park/vue/styles/index.css';
import './assets/js/lib-flexible-min'  // 引入自适应
// 引入视频播放器插件
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
// 视频兼容m3u8的需要下载插件

const hls = require('videojs-contrib-hls')
Vue.use(hls)
import { DatePicker } from '@okee-uikit/vue';
Vue.use(DatePicker);

import dataPicker from '@/components/date-picker/dataPicker'
Vue.component('dataPicker', dataPicker)

// 全局混入
import Mixin from './util/mixins';
Vue.mixin(Mixin);

Vue.prototype.$moment = moment; //赋值使用
Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(SlideVerify);
install(Vue)


router.onReady((to, from) => {
	// 屏蔽掉登录页进入添加重复路由的情况
	if (to.name === 'login') {
		return
	}

	
})

/* router.beforeEach((to, from, next) => {
	const story_user = _store.get('user')

	if (story_user && !!Object.keys(story_user).length) {
		const {
			realname = '', phone = ''
		} = story_user

		waterMark(realname + phone.substring(phone.length - 4))

		if (from.query.appId) {
			//路由切换时，如果没有就添加，有就跳过执行，添加固定参数
			if (!to.query.appId) {
				//准备一个跳转的query对象
				let {
					query,
					meta
				} = to
				query.appId = from.query.appId || ''

				if (query.appId && !meta.OffAppId) {
					next({
						path: to.path,
						query: query
					})
				} else {
					next()
				}
			} else {
				next()
			}
		} else {
			next()
		}
	} else {
		removeWaterMark()
		if (to.name === 'login') {
			next()
		} else {
			next('/login')
		}
	}
	
	if (process.env.NODE_ENV == 'production') {
		if (to.path) {
			window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
		}
	}

	next()
}) */

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')